const homeAnchorIds = new Set(["report", "checks", "how", "faq"]);

export function restoreInitialHomeAnchor(
  hash: string,
  getTarget: (id: string) => Pick<Element, "scrollIntoView"> | null,
  schedule: (callback: FrameRequestCallback) => number,
  scrollTarget: (target: Pick<Element, "scrollIntoView">) => void = (target) =>
    target.scrollIntoView({ block: "start" }),
): boolean {
  const id = hash.startsWith("#") ? hash.slice(1) : "";
  if (!homeAnchorIds.has(id)) {
    return false;
  }

  const target = getTarget(id);
  if (target === null) {
    return false;
  }

  schedule(() => scrollTarget(target));
  return true;
}

export function installInitialHomeAnchorRestore(): void {
  if (
    typeof window.addEventListener !== "function" ||
    typeof window.requestAnimationFrame !== "function"
  ) {
    return;
  }

  const restore = (): void => {
    restoreInitialHomeAnchor(
      window.location.hash,
      (id) => document.getElementById(id),
      (callback) => window.requestAnimationFrame(callback),
      (target) => {
        const previousScrollBehavior = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = "auto";
        target.scrollIntoView({ block: "start" });
        document.documentElement.style.scrollBehavior = previousScrollBehavior;
      },
    );
  };

  if (document.readyState === "complete") {
    restore();
    return;
  }

  window.addEventListener("load", restore, { once: true });
}
